import { Link } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import {
  activityConversion,
  getIdbasedOnTableVariant,
  getNavigationLinkForActivityTable,
  getTimestamp,
  getUrlForNavigation,
  isDisableBasedOnTableVariant,
  rowRedStyleCondition,
  rowStyleCondition,
} from "./helper";
import {
  tableVariant,
  columnsKeys,
  selectAll,
  unSelectAll,
  baseURL,
  targetTaskStatusOptionsObj,
} from "utils/constants";
import { useAppSelector } from "store/hooks";
import { userDetailState, userSettingState } from "store/selectors";
import {
  DeleteIcon,
  EditIcon,
  ShareProjectIcon,
  SquareCheckIcon,
  StartProgressIcon,
  StopProgressIcon,
} from "assets/svgs";
import { Button, Checkbox, Headings } from "components/ui";
import {
  AudioPlayer,
  ConditionalRenderer,
  SmallProgressBarwithRatio,
} from "components";
import {
  formatNumber,
  getProjectsTeamAssignee,
  getProjectsUserAssignee,
  getTeamProjects,
  getUserProjects,
} from "utils/helpers";
import styles from "./styles.module.css";

const {
  tasks,
  project,
  source,
  users,
  usersMainPage,

  adminLead,
  rawLead,
  polishedLead,
  callRecord,
  customerContact,
  leadRequest,
  leadTasks,
  token,
  inventory,
  taskTarget,
  individualProperty,
  completedItems,
  projectPhase,
  phaseBlocks,
  teams,
  activity: activityTable,
  projectDocuments,
  sales,
} = tableVariant;
const {
  phoneNumber,
  customer,
  action,
  timestamp,
  activity,
  lead,
  selection,
  recording,
  progress,
  // receiptId,
  tokenNo,
  propertyNumber,
  propertyNo,
  propertyUnit,
  task,
  size,
  projectName,
  projectId: projectIdColumn,
  available,
  sold,
  booked,
  notAvailable,
  teamName,
  description,
  projectAssignee,
  username,
  activitySource,
  userProjects,
  teamProjects,
  activityUser,
  activityLead,
  document,
  project: projectColumnSales,
  token: tokenColumnSales,
  salesToken,
  salesCustomer,
  leadQualifiedCall,
} = columnsKeys;
const { statusInProgress, statusStopped, statusNotStarted, statusCompleted } =
  targetTaskStatusOptionsObj;

export function CustomTable({
  columns,
  data,
  onClickDelete,
  onClickEdit,
  onClickSelect,
  onClickClose,
  onClickProgress,
  onClickAssign,
  tableFor,
  variant = "light",
  loading = false,
}: any) {
  const { isDarkMode } = useAppSelector(userSettingState);

  const [activeId, setActiveId] = useState<null | number>(null);

  return (
    <div
      className={`${styles.tableWrapper} ${styles[variant]} ${
        isDarkMode ? styles.darkMode : ""
      }`}
    >
      <table>
        <thead>
          <tr>
            {columns.map((column: any) => {
              return column?.key === selection ? (
                <RenderCheckboxHeaderColumn
                  column={column}
                  data={data}
                  onClickSelect={onClickSelect}
                  key={column?.key}
                />
              ) : (
                <th key={column?.key}>{column.header}</th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {data?.length ? (
            data.map((row: any, rowIndex: any) => {
              const leadId = row?.leadId ? row?.leadId : row?.id;
              const customerId = row?.customerId ? row?.customerId : row?.id;
              const tokenId = row?.tokenId ? row?.tokenId : row?.id;

              const propertyId = row?.propertyId ? row?.propertyId : row?.id;
              let classes = [];

              const dangerStyle = rowRedStyleCondition(row, tableFor);

              const color = rowStyleCondition(row, tableFor);

              if (color) {
                classes.push(styles?.[color]);
              }

              if (dangerStyle) {
                classes.push(styles.danger);
              }

              if (tableFor === adminLead && row?.select) {
                classes.push(styles.bgDanger);
              }

              return (
                <tr key={rowIndex} className={classes.join(" ")}>
                  {columns.map((column: any) => {
                    switch (column?.key) {
                      case phoneNumber:
                        return (
                          <td key={column.key} className="select-text">
                            <Link
                              to={`/leads/complete-detail/${leadId}`}
                              className={`${styles.link}`}
                            >
                              {row[column.key]}
                            </Link>
                          </td>
                        );
                      case lead:
                        return (
                          <td key={column.key} className="select-text">
                            <Link
                              to={`/leads/complete-detail/${leadId}`}
                              className={`${styles.link}`}
                            >
                              {row[column.key]}
                            </Link>
                          </td>
                        );

                      case leadQualifiedCall:
                        return (
                          <td key={column.key} className="select-text">
                            {row?.leadId ? (
                              <Link
                                to={`/leads/complete-detail/${row?.leadId}`}
                                className={`${styles.link}`}
                              >
                                {row[column.key]}
                              </Link>
                            ) : (
                              row[column.key] || "-"
                            )}
                          </td>
                        );

                      case activityLead:
                        return (
                          <td key={column.key} className="select-text">
                            {row[column.key] ? (
                              <Link
                                to={`/leads/complete-detail/${leadId}`}
                                className={`${styles.link}`}
                              >
                                {row[column.key]}
                              </Link>
                            ) : (
                              "-"
                            )}
                          </td>
                        );

                      case activityUser:
                        return (
                          <td key={column.key} className="select-text">
                            {row[column.key] ? (
                              <Link
                                to={`/teams/user-detail/${row?.userId}`}
                                className={styles.link}
                              >
                                {row[column.key]}
                              </Link>
                            ) : (
                              "-"
                            )}
                          </td>
                        );

                      case customer:
                        return (
                          <td key={column.key}>
                            <Link
                              to={`/customer/${customerId}`}
                              className={styles.link}
                            >
                              {row[column.key]}
                            </Link>
                          </td>
                        );

                      case salesCustomer:
                        return (
                          <td key={column.key}>
                            {row?.customerId ? (
                              <Link
                                to={`/customer/${row?.customerId}`}
                                className={styles.link}
                              >
                                {row[column.key]}
                              </Link>
                            ) : (
                              row[column?.key] || "-"
                            )}
                          </td>
                        );

                      case tokenNo:
                      case tokenColumnSales:
                        return (
                          <td key={column.key} className="select-text">
                            <Link
                              to={`/token/complete-detail/${tokenId}`}
                              className={styles.link}
                            >
                              {row[column.key]}
                            </Link>
                          </td>
                        );

                      case salesToken:
                        return (
                          <td key={column.key} className="select-text">
                            {row?.tokenId ? (
                              <Link
                                to={`/token/complete-detail/${row?.tokenId}`}
                                className={styles.link}
                              >
                                {row[column.key]}
                              </Link>
                            ) : (
                              row[column.key]
                            )}
                          </td>
                        );

                      case propertyNumber:
                      case propertyNo:
                      case propertyUnit:
                        return (
                          <td key={column.key} className="select-text">
                            <Link
                              to={`/property/complete-detail/${propertyId}?isProjectProperty=${!!row?.project}`}
                              className={styles.link}
                            >
                              {row[column.key] || row[individualProperty]}
                            </Link>
                          </td>
                        );

                      case teamName:
                        return (
                          <td key={column.key} className="select-text">
                            <Link
                              to={`/teams/team-detail/${row?.team_id}`}
                              className={styles.link}
                            >
                              {row[column.key]}
                            </Link>
                          </td>
                        );

                      case size:
                        return (
                          <td key={column.key}>
                            {row.size + " " + row.unit || "-"}
                          </td>
                        );

                      default:
                        break;
                    }

                    if (tableFor === taskTarget && column.key === description) {
                      const targetId = row?.targetId;
                      return (
                        <td key={column.key}>
                          <Link
                            to={`/add-target/complete-detail/${targetId}`}
                            className={styles.link}
                          >
                            {row[column.key] || "-"}
                          </Link>
                        </td>
                      );
                    }

                    if (
                      tableFor === activityTable &&
                      column.key === activitySource
                    ) {
                      const navigationPath =
                        getNavigationLinkForActivityTable(row);

                      return (
                        <td key={column.key}>
                          <Link
                            to={`${navigationPath}`}
                            className={styles.link}
                          >
                            {row[column.key] || "-"}
                          </Link>
                        </td>
                      );
                    }

                    if (
                      tableFor === sales &&
                      column.key === projectColumnSales
                    ) {
                      return (
                        <td key={column.key}>
                          {row[column.key] ? (
                            <Link
                              to={`/project/complete-detail/${row?.projectId}`}
                              className={styles.link}
                            >
                              {row[column.key]}
                            </Link>
                          ) : (
                            "-"
                          )}
                        </td>
                      );
                    }

                    if (tableFor === project && column.key === projectName) {
                      const projectId = row?.projectId || row?.project_id;
                      return (
                        <td key={column.key}>
                          <Link
                            to={`/project/complete-detail/${projectId}`}
                            className={styles.link}
                          >
                            {row[column.key]}
                          </Link>
                        </td>
                      );
                    }

                    if (
                      tableFor === project &&
                      column?.key === projectAssignee
                    ) {
                      return (
                        <td key={column.key} className="select-text relative">
                          {/* <ConditionalRenderer condition={row?.assigned_team}>
                            {row?.assigned_team?.map((item: any) => {
                              const url = getUrlForNavigation({
                                teamId: item?.id,
                              });
                              return (
                                <Link
                                  to={url}
                                  className={`${styles.link} block`}
                                >
                                  {item?.name}
                                </Link>
                              );
                            })}
                          </ConditionalRenderer>
                          <ConditionalRenderer condition={row?.assigned_user}>
                            {row?.assigned_user?.map((item: any) => {
                              const url = getUrlForNavigation({
                                userId: item?.user?.id,
                              });
                              return (
                                <Link
                                  to={url}
                                  className={`${styles.link} block`}
                                >
                                  {item?.user?.username}
                                </Link>
                              );
                            })}
                          </ConditionalRenderer> */}
                          <ProjectAssignee
                            projectId={row?.projectId || row?.project_id}
                          />
                        </td>
                      );
                    }

                    if (
                      tableFor === usersMainPage &&
                      column?.key === userProjects
                    ) {
                      return (
                        <td key={column.key} className="select-text">
                          <UserProjects id={row?.userId} />
                        </td>
                      );
                    }

                    if (tableFor === teams && column?.key === teamProjects) {
                      return (
                        <td key={column.key} className="select-text">
                          <TeamProjects name={row?.[teamName] || ""} />
                        </td>
                      );
                    }

                    if (
                      (tableFor === users || tableFor === usersMainPage) &&
                      column?.key === username
                    ) {
                      return (
                        <td key={column.key} className="select-text">
                          <Link
                            to={`/teams/user-detail/${row?.userId}`}
                            className={styles.link}
                          >
                            {row[column.key]}
                          </Link>
                        </td>
                      );
                    }

                    if (
                      tableFor === projectDocuments &&
                      column?.key === document
                    ) {
                      return (
                        <td key={column.key} className="select-text">
                          <Link
                            to={`${baseURL + row?.[column?.key]}`}
                            type="button"
                            className={styles.link}
                            // download={baseURL + row?.[column.key]}
                            target="_blank"
                            rel="no-refferer no-opener"
                          >
                            {row?.name}
                          </Link>
                        </td>
                      );
                    }

                    if (
                      [tasks, leadTasks, completedItems]?.includes(tableFor) &&
                      column.key === task
                    ) {
                      const taskId = row?.id;
                      return (
                        <td key={column.key}>
                          <Link
                            to={`/tasks/complete-detail/${taskId}`}
                            className={styles.link}
                          >
                            {row[column.key]}
                          </Link>
                        </td>
                      );
                    }

                    if (column.key === selection) {
                      const leadId = row?.leadId ? row?.leadId : row?.id;
                      return (
                        <td key={column.key}>
                          <Checkbox
                            onChange={() => onClickSelect(leadId)}
                            checked={row[selection]}
                          />
                        </td>
                      );
                    }

                    if (column?.key === action) {
                      return (
                        <RenderActionColumn
                          key={column?.key}
                          column={column}
                          row={row}
                          onClickDelete={onClickDelete}
                          onClickEdit={onClickEdit}
                          onClickClose={onClickClose}
                          onClickProgress={onClickProgress}
                          onClickAssign={onClickAssign}
                          tableFor={tableFor}
                        />
                      );
                    }

                    if (column?.key === timestamp) {
                      return (
                        <td key={column.key}>
                          {getTimestamp(row[column.key])}
                        </td>
                      );
                    }

                    if (column.key === activity) {
                      const activityArr = activityConversion(row[column.key]);
                      return (
                        <td key={column.key}>
                          {activityArr.map((item, index) => (
                            <p key={index} className="text-left ml-20">
                              {item}
                            </p>
                          ))}
                        </td>
                      );
                    }

                    if (column.key === recording) {
                      return (
                        <td key={column.key}>
                          {row[column.key] ? (
                            <RenderAudio
                              chatId={row?.callRecordId}
                              recording={row[column.key]}
                              activeId={activeId}
                              setActiveId={setActiveId}
                            />
                          ) : (
                            "-"
                          )}
                        </td>
                      );
                    }

                    if (column.key === progress) {
                      return (
                        <td key={column.key}>
                          <div className=" flex flex-col items-center justify-center gap-[1px]">
                            <span className="text-[10px]">
                              {formatNumber(row?.progress)}/
                              {formatNumber(row?.target_set)}
                            </span>
                            <SmallProgressBarwithRatio
                              value={row?.progress}
                              target={row?.target_set}
                              height="18px"
                            />
                          </div>
                        </td>
                      );
                    }

                    if (
                      [available, sold, booked, notAvailable].includes(
                        column?.key
                      )
                    ) {
                      const param =
                        column.key === notAvailable
                          ? "not-available"
                          : column.key;
                      return (
                        <td key={column.key}>
                          <Link
                            className={styles.link}
                            to={`/project-properties/status/${param}`}
                            state={{
                              block: row.name,
                              projectId: row?.projectId,
                              projectName: row?.projectName,
                              phase: row?.phase,
                              phaseId: row?.phaseId,
                            }}
                          >
                            {row[column.key]}
                          </Link>
                        </td>
                      );
                    }
                    return <td key={column.key}>{row[column.key] || "-"}</td>;
                  })}
                </tr>
              );
            })
          ) : (
            <NoDataFound colSpan={columns?.length} loading={loading} />
          )}
        </tbody>
      </table>
    </div>
  );
}

function RenderCheckboxHeaderColumn({ column, data, onClickSelect }) {
  // Memoize selected rows to avoid re-calculating on every render
  const selectedRows = useMemo(
    () =>
      data.filter((item: any) => {
        return item[selection] === true;
      }),
    [data]
  );

  return (
    <th key={column.key}>
      <Checkbox
        onChange={() =>
          onClickSelect(
            selectedRows.length === data.length ? unSelectAll : selectAll
          )
        }
        checked={!!(selectedRows?.length === data?.length)}
        classes="accent-white"
      />
    </th>
  );
}

function RenderActionColumn({
  column,
  row,
  onClickEdit,
  onClickDelete,
  onClickClose,
  onClickProgress,
  onClickAssign,
  tableFor,
}) {
  const { userDetail } = useAppSelector(userDetailState);
  const id = getIdbasedOnTableVariant({
    type: tableFor,
    data: row,
  });

  const isDisabled = isDisableBasedOnTableVariant({
    type: tableFor,
    data: row,
    role: userDetail?.role,
  });

  switch (tableFor) {
    case project:
      return (
        <td key={column?.key}>
          <div className="flex justify-center gap-3">
            <button
              type="button"
              title="Delete"
              className={styles.deleteBtn}
              onClick={() => onClickDelete(id)}
              disabled={isDisabled}
            >
              <DeleteIcon />
            </button>

            <button
              type="button"
              title="Edit"
              className={styles.editBtn}
              onClick={() => onClickEdit(id)}
              disabled={isDisabled}
            >
              <EditIcon />
            </button>
          </div>
        </td>
      );

    case rawLead:
    case polishedLead:
    case source:
    case token:
    case inventory:
    case projectPhase:
    case phaseBlocks:
    case projectDocuments:
      return (
        <td key={column?.key}>
          <div className="flex justify-center gap-3">
            <button
              type="button"
              title="Delete"
              className={styles.deleteBtn}
              onClick={() => onClickDelete(id)}
              disabled={isDisabled}
            >
              <DeleteIcon />
            </button>

            <button
              type="button"
              title="Edit"
              className={styles.editBtn}
              onClick={() => onClickEdit(id)}
              disabled={isDisabled}
            >
              <EditIcon />
            </button>
          </div>
        </td>
      );

    case teams:
      return (
        <td key={column?.key}>
          <div className="flex justify-center gap-3">
            <button
              type="button"
              title="Delete"
              className={styles.deleteBtn}
              onClick={() => onClickDelete(id)}
              disabled={isDisabled}
            >
              <DeleteIcon />
            </button>

            <button
              type="button"
              title="Edit"
              className={styles.editBtn}
              onClick={() => onClickEdit(id)}
              disabled={isDisabled}
            >
              <EditIcon />
            </button>

            <button
              type="button"
              title="Project Assignee"
              className={styles.editBtn}
              onClick={() => onClickAssign(id)}
              disabled={isDisabled}
            >
              <ShareProjectIcon />
            </button>
          </div>
        </td>
      );

    case taskTarget:
      return (
        <td key={column?.key}>
          <div className="flex justify-center gap-3">
            <button
              type="button"
              title="Delete"
              className={styles.deleteBtn}
              onClick={() => onClickDelete(id)}
              disabled={isDisabled}
            >
              <DeleteIcon />
            </button>

            <button
              type="button"
              title="Edit"
              className={styles.editBtn}
              onClick={() => onClickEdit(id)}
              disabled={isDisabled}
            >
              <EditIcon />
            </button>
            <ConditionalRenderer
              condition={
                row?.status === statusStopped ||
                row?.status === statusNotStarted ||
                !row?.status ||
                row?.status === statusCompleted
              }
            >
              <button
                type="button"
                title={
                  row?.status === statusCompleted
                    ? "Completed"
                    : "Start Progress"
                }
                className={styles.startBtn}
                onClick={() => onClickProgress(id, statusInProgress)}
                disabled={isDisabled}
              >
                <StartProgressIcon />
              </button>
            </ConditionalRenderer>

            <ConditionalRenderer condition={row?.status === statusInProgress}>
              <button
                type="button"
                title="Stop Progress"
                className={styles.stopBtn}
                onClick={() => onClickProgress(id, statusStopped)}
                disabled={isDisabled}
              >
                <StopProgressIcon />
              </button>
            </ConditionalRenderer>
          </div>
        </td>
      );

    case activity:
      return (
        <td key={column?.key}>
          <button
            type="button"
            title="Delete"
            className={styles.deleteBtn}
            onClick={() => onClickDelete(id)}
            // disabled={tableFor === rawLead || tableFor === polishedLead}
          >
            <DeleteIcon />
          </button>
        </td>
      );

    case callRecord:
    case sales:
      return (
        <td key={column?.key}>
          <button
            type="button"
            title="Delete"
            className={styles.deleteBtn}
            onClick={() => onClickDelete(id)}
            disabled={isDisabled}
          >
            <DeleteIcon />
          </button>
        </td>
      );

    case customerContact:
    case users:
      return (
        <td key={column?.key}>
          <button
            type="button"
            title="Edit"
            className={styles.editBtn}
            onClick={() => onClickEdit(id)}
            disabled={isDisabled}
          >
            <EditIcon />
          </button>
        </td>
      );

    case usersMainPage:
      return (
        <td key={column?.key}>
          <div className="flex  justify-center gap-2">
            <button
              type="button"
              title="Edit"
              className={styles.editBtn}
              onClick={() => onClickEdit(id)}
              disabled={isDisabled}
            >
              <EditIcon />
            </button>

            <button
              type="button"
              title="Project Assignee"
              className={styles.editBtn}
              onClick={() => onClickAssign(id)}
              disabled={isDisabled}
            >
              <ShareProjectIcon />
            </button>
          </div>
        </td>
      );

    case leadRequest:
      return (
        <td key={column?.key}>
          <Button
            type="button"
            variant="green"
            title="Approve"
            onClick={() => onClickEdit(id)}
          >
            Approve
          </Button>
        </td>
      );

    case leadTasks:
    case tasks:
      return (
        <td key={column?.key}>
          <div className="flex  justify-center gap-2">
            <button
              type="button"
              title="Close"
              className={styles.closeBtn}
              disabled={isDisabled}
              onClick={() => onClickClose(id)}
            >
              <SquareCheckIcon />
            </button>

            <button
              type="button"
              title="Edit"
              className={styles.editBtn}
              disabled={isDisabled}
              onClick={() => onClickEdit(id)}
            >
              <EditIcon />
            </button>
            <button
              type="button"
              title="Delete"
              className={styles.deleteBtn}
              onClick={() => onClickDelete(id)}
              disabled={isDisabled}
            >
              <DeleteIcon />
            </button>
          </div>
        </td>
      );

    default:
      break;
  }
}

type RenderAudioPropTypes = {
  recording: string;
  activeId: number | null;
  chatId: number;
  setActiveId: any;
};

function RenderAudio({
  recording,
  activeId,
  setActiveId,
  chatId,
}: RenderAudioPropTypes) {
  // const isSlashFirst = recording.slice(0, 1) === "/";

  // const baseURL = "http://62.72.51.210:1234/";

  // const audioSrc: string =
  //   baseURL + `${isSlashFirst ? recording.slice(1) : recording}`;
  const audioSrc: string = baseURL + `${recording}`;

  return (
    <AudioPlayer
      audioSrc={audioSrc}
      chatId={chatId}
      activeId={activeId}
      setActiveId={setActiveId}
    />
  );
}

function UserProjects({ id }) {
  const [projects, setProjects] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>();

  useEffect(() => {
    async function fetchUserProjects() {
      try {
        setLoading(true);
        const data = await getUserProjects({ id });

        setProjects(data?.objects[0]?.projects || []);
      } finally {
        setLoading(false);
      }
    }

    if (id) {
      fetchUserProjects();
    }
  }, [id]);

  return (
    <>
      <ConditionalRenderer condition={loading} key="loading">
        Loading...
      </ConditionalRenderer>
      <ConditionalRenderer condition={projects?.length}>
        {projects?.map((item: any) => {
          return (
            <Link
              to={`/project/complete-detail/${item?.project_id}`}
              className={`${styles.link} block`}
              key={item?.project_id}
            >
              {item?.project_name}
            </Link>
          );
        })}
      </ConditionalRenderer>
    </>
  );
}

function TeamProjects({ name }) {
  const [projects, setProjects] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>();

  useEffect(() => {
    async function fetchTeamProjects() {
      try {
        setLoading(true);
        const data = await getTeamProjects({ name });

        setProjects(data?.objects[0]?.assigned_projects || []);
      } finally {
        setLoading(false);
      }
    }

    if (name) {
      fetchTeamProjects();
    }
  }, [name]);

  return (
    <>
      <ConditionalRenderer condition={loading} key="loading">
        Loading...
      </ConditionalRenderer>
      <ConditionalRenderer condition={projects?.length}>
        {projects?.map((item: any) => {
          return (
            <Link
              to={`/project/complete-detail/${item?.project_id}`}
              className={`${styles.link} block`}
              key={item?.project_id}
            >
              {item?.project_name}
            </Link>
          );
        })}
      </ConditionalRenderer>
    </>
  );
}

function ProjectAssignee({ projectId }) {
  const [teams, setTeams] = useState<any>([]);
  const [users, setUsers] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>();

  useEffect(() => {
    async function fetchAssignees() {
      try {
        setLoading(true);
        const [teamRes, userRes] = await Promise.all([
          getProjectsTeamAssignee({ id: projectId }),
          getProjectsUserAssignee({ id: projectId }),
        ]);

        setTeams(teamRes?.objects || []);
        setUsers(userRes?.objects || []);
      } finally {
        setLoading(false);
      }
    }

    if (projectId) {
      fetchAssignees();
    }
  }, [projectId]);

  return (
    <>
      <ConditionalRenderer condition={loading} key="loading">
        Loading...
      </ConditionalRenderer>
      <ConditionalRenderer condition={teams.length} key="team-assignee">
        {teams?.map((item: any) => {
          const url = getUrlForNavigation({
            teamId: item?.id,
          });
          return (
            <Link to={url} className={`${styles.link} block`} key={item?.name}>
              {item?.name}
            </Link>
          );
        })}
      </ConditionalRenderer>
      <ConditionalRenderer condition={users?.length} key="user-assignee">
        {users?.map((item: any) => {
          const url = getUrlForNavigation({
            userId: item?.user?.id,
          });
          return (
            <Link
              to={url}
              className={`${styles.link} block`}
              key={item?.user?.username}
            >
              {item?.user?.username}
            </Link>
          );
        })}
      </ConditionalRenderer>
    </>
  );
}

function NoDataFound({
  colSpan,
  loading,
}: {
  colSpan: number;
  loading: boolean;
}) {
  if (loading) {
    return (
      <tr>
        <td colSpan={colSpan}></td>
      </tr>
    );
  }
  return (
    <tr>
      <td colSpan={colSpan}>
        <Headings.LevelOne classes="text-red-500 m-0 py-10">
          No Data Found
        </Headings.LevelOne>
      </td>
    </tr>
  );
}
